"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 29 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    transform: "translate(2)",
    stroke: "#016b6a",
    fill: "none",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12.5 20c4.602 0 8.769-2.667 12.5-8-3.731-5.333-7.898-8-12.5-8S3.731 6.667 0 12c3.731 5.333 7.898 8 12.5 8Z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: 12,
      cy: 12,
      r: 4
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M1 23C16.611 7.667 23.944.333 23 1"
    })]
  })]
});